import React from 'react';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { PagePathname } from '../../../routes/paths';

interface EinstellungenSeitenKopfProps {
  title: string;
}

// CONTRACT: title ist required — kein Optional-Typ, kein Default-Value.
// Compile-time-Guard: failt bei tsc (TS2322) wenn title zu string | undefined wird.
// Liegt in der Komponenten-Datei, damit der Build-Pfad die Erzwingung sicher erfasst —
// unabhaengig davon, ob tsc Test-Dateien mit einbezieht.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const titleRequiredGuard: undefined extends EinstellungenSeitenKopfProps['title'] ? never : true = true;

function EinstellungenSeitenKopf({ title }: EinstellungenSeitenKopfProps) {
  return (
    <Box data-testid="einstellungen-seiten-kopf" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <MuiLink
        component={Link}
        to={PagePathname.einstellung}
        underline="hover"
        sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}
      >
        ← Einstellungen
      </MuiLink>
      <Typography component="span" sx={{ color: 'text.secondary' }}>
        ›
      </Typography>
      <Typography component="span" color="text.primary">
        {title}
      </Typography>
    </Box>
  );
}

export default EinstellungenSeitenKopf;
